import { render, staticRenderFns } from "./NumberOfItems.vue?vue&type=template&id=ea2f72f0&scoped=true&"
import script from "./NumberOfItems.vue?vue&type=script&lang=js&"
export * from "./NumberOfItems.vue?vue&type=script&lang=js&"
import style0 from "./NumberOfItems.vue?vue&type=style&index=0&id=ea2f72f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2f72f0",
  null
  
)

export default component.exports